import { NavLink } from 'react-router-dom';
import { Phone, Mail, MapPin } from "lucide-react";
import logo from '../image/instagram-logo-png-transparent.png';

export function Footer() {
  return (
			<>
				<nav class='navbar text-white p-3' style={{ backgroundColor: '#003300' }}>
					<div class='container-fluid'>
						<div class='container'>
							<div class='row'>
								<div class='col'>
									<a href='https://www.instagram.com/epavistemoro/'>
										<img src={logo} alt=' logo instagram' width='45' height='45' />
									</a>
									<h5>Epaviste Moro</h5>
									<p style={{ fontSize: '12px' }}>
										Dépannage auto/moto, enlèvement d'épaves, évacuation d'encombrants et vide maison. Pays Basque, Béarn et landes.
									</p>
								</div>
								<div class='col'>
									<h5>Liens rapides</h5>
									<NavLink
										to='/'
										style={({ isActive, isPending }) => {
											return {
												fontSize: '12px',
												fontWeight: isActive ? 'bold' : '',
												color: isActive ? 'red' : 'white',
												textDecoration: isActive ? 'none' : 'none',
											};
										}}
									>
										Accueil
									</NavLink>
									<br />
									<NavLink
										to='/services'
										style={({ isActive, isPending }) => {
											return {
												fontSize: '12px',
												fontWeight: isActive ? 'bold' : '',
												color: isActive ? 'red' : 'white',
												textDecoration: isActive ? 'none' : 'none',
											};
										}}
									>
										Services
									</NavLink>
									<br />
									<NavLink
										to='/Commentçamarche'
										style={({ isActive, isPending }) => {
											return {
												fontSize: '12px',
												fontWeight: isActive ? 'bold' : '',
												color: isActive ? 'red' : 'white',
												textDecoration: isActive ? 'none' : 'none',
											};
										}}
									>
										Comment ça marche
									</NavLink>
									<br />
									<NavLink
										to='/Contact'
										style={({ isActive, isPending }) => {
											return {
												fontSize: '12px',
												fontWeight: isActive ? 'bold' : '',
												color: isActive ? 'red' : 'white',
												textDecoration: isActive ? 'none' : 'none',
											};
										}}
									>
										Contact
									</NavLink>
								</div>
								<div class='col'>
									<h5>Nos services</h5>
									<p style={{ fontSize: '12px' }}>
										Dépannage auto/moto 24/7
										<br />
										Enlèvement d'épaves
										<br />
										Vide maison
										<br />
										Évacuation encombrants
									</p>
								</div>
								<div class='col'>
									<h5>Contact</h5>
									<Phone size={16} color='#f80303' />
									&nbsp;
									<a href='tel:0618767935' style={{ color: '#fbfafa', textDecoration: 'none', fontSize: '12px' }}>
										06.18.76.79.35
									</a>
									<br />
									<a href='tel:0664345036' style={{ color: '#fbfafa', textDecoration: 'none', fontSize: '12px' }}>
										06.64.34.50.36
									</a>
									<br />
									<Mail size={16} color='#f80303' />
									&nbsp;
									<a href='mailto:epavistemoro@gmail.com' style={{ color: '#fbfafa', textDecoration: 'none', fontSize: '12px' }}>
										epavistemoro@gmail.com
									</a>
									<br />
									<p style={{ fontSize: '12px' }}>
										<MapPin size={16} color='#fe0101' />
										&nbsp; Résidence Lehena
										<br />
										521 Route d'Arcangues
										<br />
										64200 Bassussarry
										<br />
										Intervention 64 et 40
									</p>
								</div>
							</div>
							<hr />
							<div class='row'>
								<div class='col' style={{ fontSize: '12px' }}>
									<NavLink
										to='/copyright'
										style={({ isActive, isPending }) => {
											return {
												fontSize: '12px',
												fontWeight: isActive ? 'bold' : '',
												color: isActive ? 'red' : 'white',
												textDecoration: isActive ? 'none' : 'none',
											};
										}}
									>
										© 2026 Epaviste Moro. Tous droits réservés.
									</NavLink>
									| Kbis n° 804 689 073 R.C.S. Bayonne
								</div>
								<div class='col' style={{ fontSize: '12px' }}>
									<NavLink
										to='/mentionslegales'
										style={({ isActive, isPending }) => {
											return {
												fontSize: '12px',
												fontWeight: isActive ? 'bold' : '',
												color: isActive ? 'red' : 'white',
												textDecoration: isActive ? 'none' : 'none',
											};
										}}
									>
										Mentions légales
									</NavLink>
								</div>
								<div class='col' style={{ fontSize: '12px' }}>
									<NavLink
										to='/politiquedeconfidentialite'
										style={({ isActive, isPending }) => {
											return {
												fontSize: '12px',
												fontWeight: isActive ? 'bold' : '',
												color: isActive ? 'red' : 'white',
												textDecoration: isActive ? 'none' : 'none',
											};
										}}
									>
										Politique de confidentialité
									</NavLink>
								</div>
								<div class='col' style={{ fontSize: '12px' }}>
									<NavLink
										to='/CGU'
										style={({ isActive, isPending }) => {
											return {
												fontSize: '12px',
												fontWeight: isActive ? 'bold' : '',
												color: isActive ? 'red' : 'white',
												textDecoration: isActive ? 'none' : 'none',
											};
										}}
									>
										CGU
									</NavLink>
								</div>
							</div>
						</div>
					</div>
				</nav>
			</>
		);
}
